var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"69096d66c1e9de5e3ccb1275b5ad8b6e91d11a18"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["chaser@quidditchuk"]={id:"69096d66c1e9de5e3ccb1275b5ad8b6e91d11a18"};
      